import { configureStore } from "@reduxjs/toolkit";
import axios from "axios";
// Import userReducer after it's defined in the slice
import { userReducer  } from "./slice/usersSlice";
import { dealersReducer  } from "./slice/dealersSlice";
import { dealerReducer  } from "./slice/dealerSlice";
import { gameReducer  } from "./slice/gamesSlice";
import { studioReducer } from "./slice/studiosSlice";
import { shiftReducer } from "./slice/shiftsSlice";
import { infoReducer } from "./slice/infoSlice";
import { timeoffReducer } from "./slice/timeoffSlice";
import { mistakesReducer } from "./slice/mistakesSlice";
import { linesReducer } from "./slice/linesSlice";
import { linesGenerationReducer } from "./slice/linesGeneration";
import { reviewRequestsReducer } from "./slice/reviewRequestsSlice";

export const getToken = () => "LiveBearer "+localStorage.getItem('auth-token');

export const axiosVal = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, OPTIONS",
      "Content-Type": "application/json"
    },
});


// Now define and export the store
export default configureStore({
    reducer: {
        user: userReducer,
        dealer: dealerReducer,
        dealers: dealersReducer,
        games: gameReducer,
        lines: linesReducer,
        linesGeneration: linesGenerationReducer,
        studios: studioReducer,
        shift: shiftReducer,
        info: infoReducer,
        timeoff: timeoffReducer,
        mistakes: mistakesReducer,
        reviewRequests: reviewRequestsReducer,
    }
});
